import React, { useState, useEffect } from "react";
import css from "./TodoMobile.module.css";
import { InputWithSearchIcon } from "../../../../../stories/InputWithSearchIcon/InputWithSearchIcon";
import { Tabs } from "../../../../../stories/Tabs/Tabs";
import { Col, Container, Row } from "react-bootstrap";
import MobileCoachTodoLessonCard from "../../../../../stories/CoachTodoLessonCard/MobileCoachTodoLessonCard";
import Fonts from "../../../../../stories/assets/Fonts";
import {
  SmileIconRed,
  LessonRequestsIcon,
  StudentEvaluationIcon,
  coachDemoImg,
} from "../../../../../constant/imagePath";
import Colors from "../../../../../stories/assets/Colors";
import { LinkButtonWithIcon } from "../../../../../stories/LinkButtonWithIcon/LinkButtonWithIcon";
import { Button } from "../../../../../stories/Button/Button";
import EvaluationPerformanceMobile from "../../EvaluatePerformance/EvaluationPerformanceMobile/EvaluationPerformanceMobile";
// import TodoWithoutFinishingOnBoarding from "../../TodoWithoutFinishingOnBoarding/TodoWithoutFinishingOnBoarding";
import TodoWithoutFinishingOnMobile from "../../TodoWithoutFinishingOnBoarding/TodoWithoutFinishingOnMobile";
import TodoFilterModal from "../../../../../components/Modals/CoachFlow/Dashboard/TodoFilter/TodoFilter.jsx";

const demoData = [
  { label: "Lesson Requests", ref: React.createRef() },
  { label: "Student Evaluation", ref: React.createRef() },
  { label: "Profile reports", ref: React.createRef() },
];

// No Data Component
function NoData({ icon, title, tagline, style }) {
  return (
    <div className={css.noData}>
      <Row className={`g-0 ${css.noDataRow}`} style={{ height: "100%" }}>
        <Col md={12} className={css.firstCol}>
          <div style={style}>
            <img src={icon} />
            <h4
              style={{
                ...Fonts.h4,
                color: Colors.neutralShadesOfNero,
                fontSize: "26px",
              }}
            >
              {title}
            </h4>
            <p>{tagline}</p>
          </div>
        </Col>
        <Col md={12} className={css.lastCol}>
          <div>
            <p style={{ ...Fonts.p2, color: Colors.neutralShadesOfDimGray }}>
              Maybe we can help speed up the process by answering some{" "}
              <span style={{ ...Fonts.p2, color: Colors.mainBlue }}>
                questions
              </span>
              ?
            </p>
          </div>
        </Col>
      </Row>
    </div>
  );
}

const lessonRequestsData = [
  {
    userData: {
      displayName: "Tyler",
      profile: coachDemoImg,
    },
    time: "12:30PM- 2:30PM",
    date: "Aug 16, 2021",
    location: "DeWitt Clinton Park, W 54th St, New York, NY",
    income: "$64",
    timeLeft: "14 hrs",
    type: "pending",
    message: "absdsd",
    type: "pending",
    requestType: "1-on-1 Tennis Lesson",
  },
  {
    userData: {
      displayName: "Kate",
      profile: coachDemoImg,
    },
    time: "12:30PM- 2:30PM",
    date: "Aug 16, 2021",
    location: "DeWitt Clinton Park, W 54th St, New York, NY",
    income: "$64",
    timeLeft: "14 hrs",
    type: "pending",
    requestType: "1-on-1 Tennis Lesson",
  },
  {
    userData: {
      displayName: "Tyler",
      profile: coachDemoImg,
    },
    time: "12:30PM- 2:30PM",
    date: "Aug 16, 2021",
    location: "DeWitt Clinton Park, W 54th St, New York, NY",
    income: "$64",
    timeLeft: "14 hrs",
    type: "pending",
    requestType: "1-on-1 Tennis Lesson",
  },
];

function Todo({ setIsData }) {
  const [state, setState] = useState({ label: "Lesson Requests" });
  const [isEvaluate, setIsEvaluate] = useState(false);
  const [evaluateData, setEvaluateData] = useState([]);
  const [isFinishOnBoarding, setIsFinishOnBoarding] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);

  const [filterModal, setFilterModal] = useState(false);

  const [filterStatus, setFilterStatus] = useState();
  const [filterLocation, setFilterLocation] = useState();
  const [filterDate, setFilterDate] = useState();
  const [data, setData] = useState(lessonRequestsData);

  useEffect(() => {
    setFilterLocation();
    setFilterStatus();
  }, [state?.label]);

  // Dummy Data

  const studentEvaluationData = [
    {
      userData: {
        displayName: "Tyler",
        profile: coachDemoImg,
      },
      time: "12:30PM- 2:30PM",
      date: "Aug 16, 2021",
      location: "DeWitt Clinton Park, W 54th St, New York, NY",
      income: "$64",
      timeLeft: "14 hrs",
      onClick1: () => setShowCancelModal(true),
      type: "evaluate",
      requestType: "1-on-1 Tennis Lesson",
    },
    {
      userData: {
        displayName: "Kate",
        profile: coachDemoImg,
      },
      time: "12:30PM- 2:30PM",
      date: "Aug 16, 2021",
      location: "DeWitt Clinton Park, W 54th St, New York, NY",
      income: "$64",
      timeLeft: "14 hrs",
      type: "evaluate",
      requestType: "1-on-1 Tennis Lesson",
    },
    {
      userData: {
        displayName: "Tyler",
        profile: coachDemoImg,
      },
      time: "12:30PM- 2:30PM",
      date: "Aug 16, 2021",
      location: "DeWitt Clinton Park, W 54th St, New York, NY",
      income: "$64",
      timeLeft: "14 hrs",
      type: "read-evaluation",
      requestType: "1-on-1 Tennis Lesson",
    },
  ];

  const profileReportsData = [
    {
      text1: "Certificate Name",
      status: "expired",
      type: "certificate",
      btnText2: "Add certificate",
      description: "",
    },
    {
      text1: "declined",
      description:
        "Since onboarding check wasn’t approved - your account remains private.",
      type: "declined",
      status: "declined",
      btnText2: "Go to onboarding",
    },
  ];

  const readEvaluation = [
    {
      userData: {
        displayName: "Tyler",
        profile: coachDemoImg,
      },
      time: "12:30PM- 2:30PM",
      date: "Aug 16, 2021",
      location: "DeWitt Clinton Park, W 54th St, New York, NY",
      income: "$64",
      timeLeft: "14 hrs",
      type: "Evaluated",
      message: "absdsd",
      requestType: "1-on-1 Tennis lesson",
    },
    {
      userData: {
        displayName: "Kate",
        profile: coachDemoImg,
      },
      time: "12:30PM- 2:30PM",
      date: "Aug 16, 2021",
      location: "DeWitt Clinton Park, W 54th St, New York, NY",
      income: "$64",
      timeLeft: "14 hrs",
      type: "Evaluated",
      requestType: "1-on-1 Tennis lesson",
    },
    {
      userData: {
        displayName: "Tyler",
        profile: coachDemoImg,
      },
      time: "12:30PM- 2:30PM",
      date: "Aug 16, 2021",
      location: "DeWitt Clinton Park, W 54th St, New York, NY",
      income: "$64",
      timeLeft: "14 hrs",
      type: "Read evaluation",
      requestType: "1-on-1 Tennis lesson",
    },
  ];

  const reportData = [
    // {
    //   certificateName: "Certificate Name",
    //   status: "expired",
    // },
    // {
    //   certificateName: "Certificate Name",
    //   status: "expired",
    // },
    // {
    //   status: "declined",
    //   message:
    //     "Since onboarding check wasn’t approved - your account remains private.",
    // },
  ];

  useEffect(() => {
    if (state?.label == "Lesson Requests") {
      setData(lessonRequestsData);
    }
    if (state?.label == "Student Evaluation") {
      setData(studentEvaluationData);
    }
    if (state?.label == "Profile reports") {
      setData(profileReportsData);
    }
  }, [state]);

  // if (
  //   lessonRequestsData.length == 0 ||
  //   profileReportsData.length == 0 ||
  //   studentEvaluationData.length == 0 ||
  //   isEvaluate
  // ) {
  //   setIsData(true);
  // } else {
  //   setIsData(false);
  // }

  return (
    <div className={css.todoMainContainer}>
      {!isFinishOnBoarding ? (
        <TodoWithoutFinishingOnMobile
          setIsFinishOnBoarding={setIsFinishOnBoarding}
        />
      ) : isEvaluate ? (
        <EvaluationPerformanceMobile
          setIsEvaluate={setIsEvaluate}
          data={evaluateData}
        />
      ) : (
        <Container fluid className={`${[css.TodoMainContainer].join(" ")}`}>
          <Col sm={12} className={[css.mb16].join(" ")}>
            <h2
              style={{
                ...Fonts.h2,
                color: Colors.neutralShadesOfNero,
                fontSize: "26px",
                lineHeight: "32px",
              }}
            >
              To-do
            </h2>
          </Col>
          <Col md={12}>
            <Tabs tabsData={demoData} setState={setState} state={state} />
          </Col>
          <Col md={12} className={css.searchBox}>
            <InputWithSearchIcon
              isShowFilter={state?.label !== "Profile reports" && true}
              onFilter={() => setFilterModal(true)}
            />
            <TodoFilterModal
              show={filterModal}
              setShow={setFilterModal}
              location={filterLocation}
              setLocation={setFilterLocation}
              status={filterStatus}
              setStatus={setFilterStatus}
              tabState={state?.label === "Student Evalution" ? true : false}
              date={filterDate}
              setDate={setFilterDate}
            />
          </Col>
          <Col md={12}>
            {state?.label == "Lesson Requests" ? (
              <div className={[css.searchBox].join(" ")}>
                {data?.length == 0 ? (
                  <NoData
                    icon={LessonRequestsIcon}
                    title={"You have no lesson requests yet"}
                    tagline={
                      "As soon as the student decides to take a lesson with you it will appear in this list."
                    }
                  />
                ) : (
                  data?.map((item) => {
                    return (
                      <MobileCoachTodoLessonCard
                        lesson={item}
                        // type="Lesson-Requests"
                        // onClick1={() => {
                        //   setIsEvaluate(true);
                        // }}
                        // onClick2={() => {
                        //   console.log("first");
                        // }}
                      />
                    );
                  })
                )}
              </div>
            ) : state?.label == "Student Evaluation" ? (
              <div className={[css.searchBox].join(" ")}>
                {data?.length == 0 ? (
                  <NoData
                    icon={StudentEvaluationIcon}
                    title={"You have no student evaluations yet"}
                    tagline={
                      "As soon as you do the first lesson, student evaluation will appear here."
                    }
                  />
                ) : (
                  data?.map((item) => {
                    return (
                      <MobileCoachTodoLessonCard
                        lesson={item}
                        // type="Student-Evalution"
                        // onClick1={() => {
                        //   setIsEvaluate(true);
                        //   setEvaluateData(item);
                        // }}
                        onClick1={() => setIsEvaluate(true)}
                      />
                    );
                  })
                )}
              </div>
            ) : (
              state?.label == "Profile reports" && (
                <>
                  {data?.length == 0 ? (
                    <NoData
                      icon={SmileIconRed}
                      title={"You have no profile reports"}
                      tagline={"We will let you know if there are any issues."}
                    />
                  ) : (
                    <div className={[css.studenReport].join(" ")}>
                      {data.map((item) => {
                        return (
                          <div
                            style={{
                              borderBottom: `1px solid ${Colors.neutralShadesOfGainsboro}`,
                            }}
                            className={[css.studenReportCard].join(" ")}
                          >
                            <div className={[css.studentReportheading]}>
                              {item?.type == "certificate" ? (
                                <p
                                  style={{
                                    ...Fonts.p1,
                                    color: Colors.neutralShadesOfNero,
                                  }}
                                >
                                  Your
                                  <span
                                    style={{
                                      ...Fonts.h7,
                                      lineHeight: "24px",
                                    }}
                                  >
                                    {" "}
                                    "{item?.text1}"{" "}
                                  </span>
                                  Certificate has been {item?.status}
                                </p>
                              ) : (
                                item?.type == "declined" && (
                                  <p
                                    style={{
                                      ...Fonts.p1,
                                      color: Colors.neutralShadesOfNero,
                                    }}
                                  >
                                    Your onboarding has been {item?.status}
                                  </p>
                                )
                              )}
                              <p
                                style={{
                                  ...Fonts.b1Mobile,
                                  color: Colors.neutralShadesOfDimGray,
                                  paddingTop: "5px",
                                }}
                              >
                                {item?.description}
                              </p>
                            </div>
                            <div className={[css.studentReportFooter]}>
                              <LinkButtonWithIcon
                                text={"Contact us"}
                                textColor={Colors.neutralShadesOfNero}
                                customStyle={{
                                  ...Fonts.b2,
                                }}
                              />
                              <Button
                                label={item?.btnText2}
                                customStyle={{
                                  ...Fonts.b2,
                                  padding: "14px 24px",
                                  border: `1px solid ${Colors.neutralShadesOfGainsboro}`,
                                  width: "179px",
                                }}
                                primary={true}
                                size="Medium"
                              />
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </>
              )
            )}
          </Col>
        </Container>
      )}
    </div>
  );
}

export default Todo;
